import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/volcanobet/images/logo.svg';

export default function Index() {
  return <Image src={logo} maxW="40" ml="2" />;
}
